import { getTemperature } from '../../../../helper/temperature';

export function P00058SeuilTemperatureHorsGel() {
  let r = [];

  for (let i = -1; i <= 3; i++) {
    r.push({
      ref: i,
      label: getTemperature(i, 0),
    });
  }

  return r;
}
